import { CLIENT_PITCHES } from "./clientPitches";
import { CLIENT_SERVICES } from "./clientServices";

// Client roster for HighwaysIndustry.com
// Coordinates geocoded from postcodes.io. Slug is derived from client name.

const slugify = (s) =>
  s
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const raw = [
  {
    name: "ACO",
    address: "ACO Business Park, Hitchin Road, Shefford, Bedfordshire",
    postcode: "SG17 5TE",
    lat: 52.020704,
    lng: -0.312526,
    domain: "aco.co.uk",
    description:
      "Drainage and water-management manufacturer supplying channel drainage, attenuation, treatment and surface-water systems.",
    hiActivity:
      "Product news, drainage case studies, technical guidance and project coverage.",
    hiSearch: "https://www.highwaysindustry.com/?s=ACO",
  },
  {
    name: "Blakedale",
    address:
      "Sterling House, 2-4 Mill Lane, Whittle-le-Woods, Chorley, Lancashire",
    postcode: "PR6 7LX",
    lat: 53.693174,
    lng: -2.636119,
    domain: "blakedale.co.uk",
    description:
      "Supplier and hirer of traffic-management vehicles, impact protection vehicles, road marker posts and safety products.",
    hiActivity:
      "Vehicle fleet news, product launches, road-marker projects and safety features.",
    hiSearch: "https://www.highwaysindustry.com/?s=Blakedale",
    featureArticle:
      "https://www.highwaysindustry.com/blakedale-not-just-a-hire-fleet-chevron-tm-collaboration-showcases-both-sides-to-the-business/",
  },
  {
    name: "Blinc Light",
    address:
      "Unit 19 Castle View Business Park, Gas House Road, Rochester, Kent",
    postcode: "ME1 1PB",
    lat: 51.391511,
    lng: 0.506928,
    domain: "blinclight.com",
    description:
      "Manufacturer of illuminated Chapter 8 vehicle markings, illuminated chevrons, signage and visibility products.",
    hiActivity:
      "Partner articles, product education, safety campaigns, demonstrations, case studies and video.",
    hiSearch: "https://www.highwaysindustry.com/?s=Blinc+Light",
    featureArticle:
      "https://www.highwaysindustry.com/blinc-light-new-website-is-live-a-new-home-for-safety-innovation/",
  },
  {
    name: "BT-HS",
    address: "Unit 27 Twin Lakes Industrial Estate, Bretherton Road, Croston",
    postcode: "PR26 9RF",
    lat: 53.665535,
    lng: -2.780404,
    domain: "bt-hs.com",
    description:
      "Highways contractor and service provider delivering traffic management, civil engineering and related infrastructure works.",
    hiActivity:
      "Company profiles, team stories, charity activity, project news, recruitment and video features.",
    hiSearch: "https://www.highwaysindustry.com/?s=BT-HS",
    caseStudySlug: "bt-hs-electric-ipv",
  },
  {
    name: "Cappagh",
    address: "Cappagh House, Waterside Way, Wimbledon, London",
    postcode: "SW17 0HB",
    lat: 51.425928,
    lng: -0.183895,
    domain: "cappagh.co.uk",
    description:
      "Civil engineering and utility contractor delivering highways, drainage, utilities, waste and infrastructure services.",
    hiActivity:
      "Corporate news, project case studies, people features, sustainability and campaign content.",
    hiSearch: "https://www.highwaysindustry.com/?s=Cappagh",
  },
  {
    name: "CD Fencing",
    address: "Chippenham",
    postcode: "SN14 6DG",
    lat: 51.511798,
    lng: -2.137432,
    domain: "cdfencing.co.uk",
    description:
      "Supplier and installer of temporary and permanent fencing, gates, barriers and site-security systems.",
    hiActivity:
      "Product features, project features, site-security content and partner promotion.",
    hiSearch: "https://www.highwaysindustry.com/?s=CD+Fencing",
  },
  {
    name: "Chellan Highway Safety Services",
    address: "Ashtree House, Moss Road, Doncaster, South Yorkshire",
    postcode: "DN6 0HH",
    lat: 53.621575,
    lng: -1.101075,
    domain: "chellanhighwaysafety.co.uk",
    description:
      "Road-marking and highway-safety contractor providing lining, studs, anti-skid and specialist surfacing services.",
    hiActivity:
      "Company news, project coverage and road-marking or safety-service promotion.",
    hiSearch:
      "https://www.highwaysindustry.com/?s=Chellan+Highway+Safety+Services",
  },
  {
    name: "City TM",
    address:
      "Unit 2 A & B, Smallford Business Park, Smallford Lane, St Albans",
    postcode: "AL4 0SA",
    lat: 51.746152,
    lng: -0.264908,
    domain: "citytm.co.uk",
    description:
      "Traffic-management contractor providing temporary traffic management, event traffic control and highway support.",
    hiActivity:
      "Company updates, project stories, recruitment and traffic-management industry features.",
    hiSearch: "https://www.highwaysindustry.com/?s=City+TM",
  },
  {
    name: "Coeval",
    address: "Clyde Offices, 2nd Floor, 48 West George Street, Glasgow",
    postcode: "G2 1BP",
    lat: 55.862095,
    lng: -4.253227,
    domain: "coeval.uk.com",
    description:
      "Traffic-safety and intelligent transport systems specialist supplying vehicle-activated signs, warning systems and monitoring technology.",
    hiActivity:
      "Technology launches, product explainers, case studies and road-safety campaigns.",
    hiSearch: "https://www.highwaysindustry.com/?s=Coeval",
  },
  {
    name: "Consilium Technical Services",
    address: "Unit 101, Fort Dunlop, Fort Parkway, Birmingham",
    postcode: "B24 9FD",
    lat: 52.510078,
    lng: -1.811234,
    domain: "consiliumts.com",
    description:
      "Specialist consultancy and technical-services business supporting highways, transport and infrastructure projects.",
    hiActivity:
      "Technical thought leadership, company news, appointments and project features.",
    hiSearch:
      "https://www.highwaysindustry.com/?s=Consilium+Technical+Services",
  },
  {
    name: "Core Highways",
    address:
      "Unit A, Ground Floor, Moorgate House, 201 Silbury Boulevard, Milton Keynes",
    postcode: "MK9 1JL",
    lat: 52.039093,
    lng: -0.770102,
    domain: "corehighways.com",
    description:
      "National traffic-management and barrier-services group providing temporary traffic management and infrastructure support.",
    hiActivity:
      "Business updates, acquisitions, projects, safety, recruitment and partner news.",
    hiSearch: "https://www.highwaysindustry.com/?s=Core+Highways",
  },
  {
    name: "Crown Highways",
    address:
      "Unit 5 Queens Drive Industrial Estate, Chasetown, Burntwood, Staffordshire",
    postcode: "WS7 4QF",
    lat: 52.671396,
    lng: -1.929026,
    domain: "crownhighways.co.uk",
    description:
      "Highways electrical, lighting and civil-engineering contractor working on road networks and infrastructure projects.",
    hiActivity:
      "Project case studies, company news, awards, community activity, recruitment and video.",
    hiSearch: "https://www.highwaysindustry.com/?s=Crown+Highways",
  },
  {
    name: "Crown Plus",
    address: "Haldene Business Centre, Halesfield 2, Telford",
    postcode: "TF7 4QH",
    lat: 52.644243,
    lng: -2.42171,
    domain: "crownplus.co.uk",
    description:
      "Highways and infrastructure support business providing specialist labour, plant and project services.",
    hiActivity:
      "Company updates, recruitment, project stories and partner promotion.",
    hiSearch: "https://www.highwaysindustry.com/?s=Crown+Plus",
  },
  {
    name: "DELTABLOC UK",
    address: "2175 Thorpe Park, Leeds",
    postcode: "LS15 8ZB",
    lat: 53.796838,
    lng: -1.426444,
    domain: "deltabloc.co.uk",
    description:
      "Manufacturer and supplier of concrete and steel vehicle-restraint systems, temporary barriers and crash-protection products.",
    hiActivity:
      "Barrier product launches, technical articles, project case studies and safety content.",
    hiSearch: "https://www.highwaysindustry.com/?s=DELTABLOC+UK",
  },
  {
    name: "Highway Care",
    address: "Trinity House 3 Bullace Lane, Dartford, Kent",
    postcode: "DA1 1BB",
    lat: 51.444185,
    lng: 0.220272,
    domain: "highwaycare.com",
    description:
      "Supplier and installer of road-safety systems including barriers, vehicle-restraint products, automated gates and work-zone technology.",
    hiActivity:
      "Innovation features, product launches, trials, project case studies, safety campaigns and video.",
    hiSearch: "https://www.highwaysindustry.com/?s=Highway+Care",
    caseStudySlug: "highway-care-falcon-aclm",
  },
  {
    name: "Hill & Smith Infrastructure",
    address: "Palmer Drive, Stapleford, Nottingham",
    postcode: "NG9 7BW",
    lat: 52.920787,
    lng: -1.277722,
    domain: "hillandsmithinfrastructure.com",
    description:
      "Manufacturer of vehicle-restraint systems, bridge parapets, temporary barriers and infrastructure safety products.",
    hiActivity:
      "Product news, project news, technical content, safety features and industry announcements.",
    hiSearch:
      "https://www.highwaysindustry.com/?s=Hill+%26+Smith+Infrastructure",
  },
  {
    name: "HRS",
    address:
      "Unit 17, Barbrey Business Park, Orston Lane, Bottesford, Leicestershire",
    postcode: "NG13 0GY",
    lat: 52.944075,
    lng: -0.815271,
    domain: "hrsgroup.com",
    description:
      "Road-safety technology company providing automated taper, work-zone protection and digital safety systems.",
    hiActivity:
      "Technology education, innovation case studies, product demonstrations, safety campaigns and video.",
    hiSearch: "https://www.highwaysindustry.com/?s=HRS",
  },
  {
    name: "HTM",
    address: "60 Tyburn Road, Birmingham",
    postcode: "B24 8LA",
    lat: 52.508784,
    lng: -1.856975,
    domain: "htm.co.uk",
    description:
      "Traffic-management contractor delivering high-speed, urban and event traffic-management services.",
    hiActivity:
      "Company news, charity and community stories, recruitment, project coverage and team features.",
    hiSearch: "https://www.highwaysindustry.com/?s=HTM",
  },
  {
    name: "Hireway",
    address: "100 Tyburn Road, Birmingham",
    postcode: "B24 8LA",
    lat: 52.509784,
    lng: -1.855975,
    domain: "hireway.co.uk",
    description:
      "Vehicle and specialist fleet-hire company serving traffic management, highways and construction.",
    hiActivity:
      "Fleet news, vehicle features, company updates and partner promotion.",
    hiSearch: "https://www.highwaysindustry.com/?s=Hireway",
  },
  {
    name: "Institute of Asphalt Technology",
    address: "National Stone Centre, Porter Lane, Wirksworth",
    postcode: "DE4 4LS",
    lat: 53.094294,
    lng: -1.583162,
    domain: "instituteofasphalt.org",
    description:
      "Professional institute supporting asphalt, surfacing and pavement professionals through membership, training and technical knowledge.",
    hiActivity:
      "Industry events, awards, training, technical announcements and professional-development coverage.",
    hiSearch:
      "https://www.highwaysindustry.com/?s=Institute+of+Asphalt+Technology",
  },
  {
    name: "Instarmac",
    address: "Danny Morson Way, Dordon, Tamworth",
    postcode: "B78 1SE",
    lat: 52.593504,
    lng: -1.624842,
    domain: "instarmac.co.uk",
    description:
      "Manufacturer of highway maintenance, repair, bedding, grouting and construction-material products, including UltraCrete.",
    hiActivity:
      "Product launches, technical guides, case studies, awards and highway-repair content.",
    hiSearch: "https://www.highwaysindustry.com/?s=Instarmac",
  },
  {
    name: "Kiely Bros",
    address:
      "135 Cherrywood Road, Bordesley Green, Birmingham, West Midlands",
    postcode: "B9 4XE",
    lat: 52.479391,
    lng: -1.852978,
    domain: "kielybros.co.uk",
    description:
      "Highways maintenance group specialising in surface treatments, road marking, traffic management and carriageway services.",
    hiActivity:
      "Project case studies, company news, recruitment, awards, sustainability and technical features.",
    hiSearch: "https://www.highwaysindustry.com/?s=Kiely+Bros",
  },
  {
    name: "Kier Transportation Services",
    address: "2nd Floor Optimum House, Clippers Quay, Salford",
    postcode: "M50 3XP",
    lat: 53.467312,
    lng: -2.287569,
    domain: "kier.co.uk",
    description:
      "Major infrastructure contractor delivering highways maintenance, road projects, structures, street lighting and transport services.",
    hiActivity:
      "Contract wins, project news, innovation, awards, safety, sustainability, recruitment and HDS-related coverage.",
    hiSearch:
      "https://www.highwaysindustry.com/?s=Kier+Transportation+Services",
    caseStudySlug: "hds-kier-drone-inspections",
  },
  {
    name: "King Highway Products",
    address: "Riverside, Market Harborough, Leicestershire",
    postcode: "LE16 7PX",
    lat: 52.481479,
    lng: -0.906155,
    domain: "king.uk.com",
    description:
      "Manufacturer and supplier of road-maintenance equipment, patching systems, asphalt heaters and highways machinery.",
    hiActivity:
      "Equipment launches, demonstrations, technical articles, case studies and partner campaigns.",
    hiSearch: "https://www.highwaysindustry.com/?s=King+Highway+Products",
    websiteUrl: "https://king.uk.com/king-highway/",
    caseStudySlug: "king-highways-emcc",
  },
  {
    name: "MAC Surfacing",
    address: "4 Malthouse Road, Tipton, West Midlands",
    postcode: "DY4 9AE",
    lat: 52.529586,
    lng: -2.076249,
    domain: "macsurfacing.com",
    description:
      "Road-surfacing contractor providing asphalt, resurfacing, planing and associated highway works.",
    hiActivity:
      "Project coverage, company updates, surfacing features and partner promotion.",
    hiSearch: "https://www.highwaysindustry.com/?s=MAC+Surfacing",
  },
  {
    name: "M Group Telecom",
    address: "Gunnels Wood Road, Stevenage",
    postcode: "SG1 2ST",
    lat: 51.898836,
    lng: -0.213174,
    domain: "mgroupltd.com",
    description:
      "Infrastructure services provider delivering telecoms network design, construction, maintenance and field services.",
    hiActivity:
      "Corporate and project coverage, innovation, workforce and infrastructure news.",
    hiSearch: "https://www.highwaysindustry.com/?s=M+Group+Telecom",
  },
  {
    name: "Meon",
    address: "Railside, Northarbour Spur, Portsmouth",
    postcode: "PO6 3TU",
    lat: 50.845907,
    lng: -1.08455,
    domain: "meonuk.com",
    description:
      "Supplier of line-marking, surface-repair, resin, anti-skid and highways maintenance systems and equipment.",
    hiActivity:
      "Product education, demonstrations, case studies, training content and surface-material campaigns.",
    hiSearch: "https://www.highwaysindustry.com/?s=Meon",
  },
  {
    name: "Messagemaker Displays / Stocksigns Ltd",
    address:
      "43 Ormside Way, Holmethorpe Industrial Estate, Redhill, Surrey",
    postcode: "RH1 2LG",
    lat: 51.252779,
    lng: -0.156718,
    domain: "messagemaker.co.uk",
    description:
      "Manufacturer of variable-message signs, LED displays, speed signs and road-safety signage, part of Stocksigns.",
    hiActivity:
      "Product launches, signage technology, safety campaigns, case studies and company news.",
    hiSearch: "https://www.highwaysindustry.com/?s=Messagemaker+Displays",
  },
  {
    name: "Metelec Services",
    address:
      "Unit 12 Bingham's Park Farm, Water End, Hemel Hempstead",
    postcode: "HP1 3BN",
    lat: 51.776071,
    lng: -0.506556,
    domain: "met-elec.co.uk",
    description:
      "Electrical and mechanical contractor providing lighting, power, installation and maintenance services.",
    hiActivity:
      "Company news, projects, people updates and electrical-infrastructure features.",
    hiSearch: "https://www.highwaysindustry.com/?s=Metelec+Services",
  },
  {
    name: "Miles Macadam",
    address: "Malpas Station, Hampton, Cheshire",
    postcode: "SY14 8LU",
    lat: 53.038194,
    lng: -2.752278,
    domain: "milesmacadam.co.uk",
    description:
      "Specialist surfacing contractor and manufacturer known for Hardipave and other asphalt and surface-treatment systems.",
    hiActivity:
      "Project case studies, technical surfacing content, company news, awards and video.",
    hiSearch: "https://www.highwaysindustry.com/?s=Miles+Macadam",
  },
  {
    name: "Milestone Infrastructure",
    address:
      "Abel Smith House, Gunnels Wood Road, Stevenage, Hertfordshire",
    postcode: "SG1 2ST",
    lat: 51.899836,
    lng: -0.214174,
    domain: "mgroupltd.com",
    description:
      "Highways maintenance and infrastructure services provider, now part of M Group Highways, working for local authorities and transport clients.",
    hiActivity:
      "Contract wins, project news, innovation, sustainability, community activity and recruitment.",
    hiSearch: "https://www.highwaysindustry.com/?s=Milestone+Infrastructure",
  },
  {
    name: "Multevo",
    address:
      "Units 1-3 Off Charles Street, Duckworth Street, Darwen, Lancashire",
    postcode: "BB3 1BF",
    lat: 53.699956,
    lng: -2.471714,
    domain: "multevo.co.uk",
    description:
      "Provider of multi-purpose highways equipment, patching services and road-maintenance contracting.",
    hiActivity:
      "Machine demonstrations, maintenance case studies, product news, contracts and video.",
    hiSearch: "https://www.highwaysindustry.com/?s=Multevo",
  },
  {
    name: "National Highways",
    address: "Three Snowhill, Snow Hill Queensway, Birmingham",
    postcode: "B4 6GA",
    lat: 52.484141,
    lng: -1.898832,
    domain: "nationalhighways.co.uk",
    description:
      "Government-owned company responsible for operating, maintaining and improving England's strategic road network.",
    hiActivity:
      "National project news, road schemes, safety campaigns, innovation, procurement and network updates.",
    hiSearch: "https://www.highwaysindustry.com/?s=National+Highways",
    featureArticle:
      "https://www.highwaysindustry.com/super-swift-gates-which-automatically-close-off-lanes-to-be-trialled-on-national-highways-network/",
  },
  {
    name: "Nissen UK",
    address: "239-241 Kennington Lane, London",
    postcode: "SE11 5QU",
    lat: 51.486711,
    lng: -0.113884,
    domain: "nissen.co.uk",
    description:
      "Supplier of traffic-management lighting, warning lamps, barriers, signs and work-zone safety equipment.",
    hiActivity:
      "Product launches, technical features, exhibitions, safety content and partner news.",
    hiSearch: "https://www.highwaysindustry.com/?s=Nissen+UK",
  },
  {
    name: "PoGo",
    address:
      "1 Maxted Corner, Maxted Road, Hemel Hempstead Industrial Estate, Hemel Hempstead",
    postcode: "HP2 7RA",
    lat: 51.766672,
    lng: -0.437247,
    domain: "pogocharge.com",
    description:
      "Public electric-vehicle charging network operated by SWARCO Smart Charging.",
    hiActivity:
      "EV charging launches, network growth, site openings, partnerships and clean-transport content.",
    hiSearch: "https://www.highwaysindustry.com/?s=PoGo",
  },
  {
    name: "R&C Williams",
    address:
      "Spaghetti Junction, 1 Tyburn Road, Erdington, Birmingham, West Midlands",
    postcode: "B24 8NP",
    lat: 52.508372,
    lng: -1.858008,
    domain: "rcwilliams.co.uk",
    description:
      "Civil-engineering contractor specialising in bridge repairs, structural maintenance, highways and public-realm projects.",
    hiActivity:
      "Project case studies, awards, staff stories, community activity, accreditation and video.",
    hiSearch: "https://www.highwaysindustry.com/?s=R%26C+Williams",
    caseStudySlug: "rc-williams",
  },
  {
    name: "Ramudden Global UK (Chevron TM)",
    address: "141-149 Salisbury House, London Wall, London",
    postcode: "EC2M 5QQ",
    lat: 51.517228,
    lng: -0.087572,
    domain: "chevrontm.com",
    description:
      "National traffic-management and work-zone safety group, part of Ramudden Global.",
    hiActivity:
      "Contract news, acquisitions, safety, innovation, project features, recruitment and group updates.",
    hiSearch:
      "https://www.highwaysindustry.com/?s=Ramudden+Global+UK+%28Chevron+TM%29",
  },
  {
    name: "Re-flow",
    address: "The Mount, 72 Paris Street, Exeter",
    postcode: "EX1 2JY",
    lat: 50.725012,
    lng: -3.523878,
    domain: "re-flow.co.uk",
    description:
      "Field-management software platform for highways, construction and infrastructure businesses.",
    hiActivity:
      "Software education, customer case studies, webinars, compliance, productivity content and event coverage.",
    hiSearch: "https://www.highwaysindustry.com/?s=Re-flow",
  },
  {
    name: "Roadway TM",
    address: "York",
    postcode: "YO19 6QR",
    lat: 53.825067,
    lng: -1.033301,
    domain: "roadwaytm.co.uk",
    description:
      "Traffic-management contractor delivering high-speed and local-road temporary traffic management.",
    hiActivity:
      "Project news, community activity, digital traffic-management features, recruitment and company updates.",
    hiSearch: "https://www.highwaysindustry.com/?s=Roadway+TM",
  },
  {
    name: "SHIMPAC",
    address: "Keepers Cottage, Catmere End, Saffron Walden, Essex",
    postcode: "CB11 4XG",
    lat: 52.033211,
    lng: 0.174181,
    domain: "shimpac.co.uk",
    description:
      "Supplier of impact-protection and crash-cushion products for works vehicles and highway safety.",
    hiActivity:
      "Product education, safety features, demonstrations and partner promotion.",
    hiSearch: "https://www.highwaysindustry.com/?s=SHIMPAC",
  },
  {
    name: "Solar Gates",
    address:
      "The Packhouse, Heath Road, Boughton Monchelsea, Maidstone, Kent",
    postcode: "ME17 4JB",
    lat: 51.226719,
    lng: 0.539084,
    domain: "solargates.co.uk",
    description:
      "Manufacturer of solar-powered automatic barriers and access-control systems, including work-zone incursion protection.",
    hiActivity:
      "Product launches, incursion-control case studies, demonstrations, safety campaigns and video.",
    hiSearch: "https://www.highwaysindustry.com/?s=Solar+Gates",
  },
  {
    name: "SWARCO",
    address: "7 Mercury Road, Richmond",
    postcode: "DL10 4TQ",
    lat: 54.412058,
    lng: -1.748919,
    domain: "swarco.com",
    description:
      "Global provider of road-marking systems, traffic signals, intelligent transport systems and mobility technology.",
    hiActivity:
      "Technology launches, contracts, road marking, ITS projects, sustainability and company news.",
    hiSearch: "https://www.highwaysindustry.com/?s=SWARCO",
  },
  {
    name: "SWARCO Smart Charging",
    address:
      "1 Maxted Corner, Maxted Road, Hemel Hempstead Industrial Estate, Hemel Hempstead, Hertfordshire",
    postcode: "HP2 7RA",
    lat: 51.767672,
    lng: -0.436247,
    domain: "swarco.com",
    description:
      "Electric-vehicle charging infrastructure provider delivering hardware, software, installation and network services.",
    hiActivity:
      "EV charging projects, partnerships, network launches, technology and clean-transport features.",
    hiSearch: "https://www.highwaysindustry.com/?s=SWARCO+Smart+Charging",
  },
  {
    name: "Tailored Highway Support (THS)",
    address:
      "Unit 8 Laceby Business Park, Laceby, Grimsby, North East Lincolnshire",
    postcode: "DN37 7DP",
    lat: 53.541062,
    lng: -0.161783,
    domain: "tailoredhighwaysupport.co.uk",
    description:
      "Highways support provider offering training, consultancy, traffic-management support and workforce services.",
    hiActivity:
      "Training promotion, company news, safety guidance, staff features and video.",
    hiSearch:
      "https://www.highwaysindustry.com/?s=Tailored+Highway+Support+%28THS%29",
  },
  {
    name: "Tarmac",
    address: "Ground Floor T3 Trinity Park, Bickenhill Lane, Birmingham",
    postcode: "B37 7ES",
    lat: 52.446656,
    lng: -1.7213,
    domain: "tarmac.com",
    description:
      "Major UK construction-materials and road-services company supplying asphalt, aggregates, concrete and highways contracting.",
    hiActivity:
      "Projects, materials, sustainability, innovation, awards, contracts and industry news.",
    hiSearch: "https://www.highwaysindustry.com/?s=Tarmac",
    caseStudySlug: "tarmac-silverstone-resurfacing",
  },
  {
    name: "THS Training",
    address:
      "Unit 8 Laceby Business Park, Laceby, Grimsby, North East Lincolnshire",
    postcode: "DN37 7DP",
    lat: 53.542062,
    lng: -0.160783,
    domain: "thstraining.co.uk",
    description:
      "Highways and traffic-management training provider delivering Lantra and industry qualifications.",
    hiActivity:
      "Course promotion, qualification guidance, training videos, company news and learner content.",
    hiSearch: "https://www.highwaysindustry.com/?s=THS+Training",
  },
  {
    name: "Thomson Protective Coatings",
    address:
      "Venture Point, Towers Business Park, Wheelhouse Road, Brereton, Rugeley, Staffordshire",
    postcode: "WS15 1UZ",
    lat: 52.75056,
    lng: -1.916647,
    domain: "thomsonpc.co.uk",
    description:
      "Specialist protective-coatings contractor for bridges, steelwork and infrastructure assets.",
    hiActivity:
      "Project case studies, technical coating content, accreditations, awards and company updates.",
    hiSearch:
      "https://www.highwaysindustry.com/?s=Thomson+Protective+Coatings",
  },
  {
    name: "TMCA",
    address: "60 Tyburn Road, Erdington, Birmingham, West Midlands",
    postcode: "B24 8LA",
    lat: 52.510784,
    lng: -1.854975,
    domain: "tmca.uk.com",
    description:
      "Trade association representing UK traffic-management contractors and promoting standards, safety and industry interests.",
    hiActivity:
      "Association announcements, events, guidance, member news and traffic-management sector coverage.",
    hiSearch: "https://www.highwaysindustry.com/?s=TMCA",
  },
  {
    name: "Traffic Group Signals",
    address:
      "White Lion House, Gloucester Road, Staverton, Cheltenham, Gloucestershire",
    postcode: "GL51 0TF",
    lat: 51.900235,
    lng: -2.157466,
    domain: "trafficgroupsignals.com",
    description:
      "Manufacturer and hirer of portable traffic signals and intelligent temporary traffic-management technology.",
    hiActivity:
      "Product launches, technology explainers, case studies, sustainability and company news.",
    hiSearch: "https://www.highwaysindustry.com/?s=Traffic+Group+Signals",
  },
  {
    name: "Traffic Labour Supplies (TLS)",
    address: "19 Churchgate, Retford, Nottinghamshire",
    postcode: "DN22 6PF",
    lat: 53.32227,
    lng: -0.94317,
    domain: "tlsltd.org",
    description:
      "Recruitment and labour-supply business serving traffic management, highways and construction.",
    hiActivity:
      "Recruitment campaigns, company news, charity activity, vacancies and workforce features.",
    hiSearch:
      "https://www.highwaysindustry.com/?s=Traffic+Labour+Supplies+%28TLS%29",
  },
  {
    name: "Transport for London",
    address: "5 Endeavour Square, Stratford, London",
    postcode: "E20 1JN",
    lat: 51.542021,
    lng: -0.00919,
    domain: "tfl.gov.uk",
    description:
      "Public body responsible for London's transport network, including roads, buses, rail, cycling and major highway programmes.",
    hiActivity:
      "London road-project news, contracts, safety, policy, traffic schemes and transport announcements.",
    hiSearch: "https://www.highwaysindustry.com/?s=Transport+for+London",
  },
  {
    name: "Triangle Software",
    address:
      "Suite 4, Tredomen Business and Technology Centre, Tredomen Park, Ystrad Mynach, Hengoed",
    postcode: "CF82 7FN",
    lat: 51.64423,
    lng: -3.246931,
    domain: "trianglesoftware.co.uk",
    description:
      "Developer of software for traffic-management and field-service businesses, including job, asset and operational management tools.",
    hiActivity:
      "Software product features, customer stories, digital transformation content and partner news.",
    hiSearch: "https://www.highwaysindustry.com/?s=Triangle+Software",
  },
  {
    name: "Up To Speed Training",
    address: "411 Long Acre, Nechells, Birmingham",
    postcode: "B7 5JX",
    lat: 52.505054,
    lng: -1.864943,
    domain: "utstraining.co.uk",
    description:
      "Training provider for traffic management, highways, plant and workplace safety qualifications.",
    hiActivity:
      "Course campaigns, training advice, company news, learner stories and industry guidance.",
    hiSearch: "https://www.highwaysindustry.com/?s=Up+To+Speed+Training",
  },
  {
    name: "UK Sandbags",
    address:
      "Rear of Warp Farm, Moorends Road, Moorends, Doncaster, South Yorkshire",
    postcode: "DN8 4JY",
    lat: 53.644106,
    lng: -0.95444,
    domain: "uksandbags.co.uk",
    description:
      "Supplier of filled sandbags, flood-protection products, aggregates and emergency-response materials.",
    hiActivity:
      "Product features, flood-response content, company news and partner promotion.",
    hiSearch: "https://www.highwaysindustry.com/?s=UK+Sandbags",
  },
  {
    name: "Velocity",
    address: "Woodbine Street, Sunderland",
    postcode: "SR1 2NL",
    lat: 54.904771,
    lng: -1.368306,
    domain: "velocityroads.co.uk",
    description:
      "Road-repair and highways-maintenance contractor using spray-injection patching and mobile repair systems.",
    hiActivity:
      "Pothole-repair case studies, council contracts, technology, productivity and company news.",
    hiSearch: "https://www.highwaysindustry.com/?s=Velocity",
  },
  {
    name: "VolkerHighways",
    address: "Hertford Road, Hoddesdon, Hertfordshire",
    postcode: "EN11 9BX",
    lat: 51.771495,
    lng: -0.035388,
    domain: "volkerhighways.co.uk",
    description:
      "Highways contractor delivering term maintenance, street lighting, public realm, surfacing and civil engineering.",
    hiActivity:
      "Contract wins, project updates, sustainability, innovation, awards and recruitment.",
    hiSearch: "https://www.highwaysindustry.com/?s=VolkerHighways",
  },
  {
    name: "WDM",
    address: "North View, Bristol",
    postcode: "BS16",
    lat: 51.483743,
    lng: -2.552896,
    domain: "wdm.co.uk",
    description:
      "Highway asset-management and road-survey specialist manufacturing SCRIM and other condition-survey equipment.",
    hiActivity:
      "Survey technology, road-condition data, international projects, appointments and technical features.",
    hiSearch: "https://www.highwaysindustry.com/?s=WDM",
    featureArticle: "https://www.highwaysindustry.com/wdm-ltd/",
  },
  {
    name: "WJ",
    address:
      "Unit 7 Brock Way, Knutton, Newcastle-under-Lyme, Staffordshire",
    postcode: "ST5 6AZ",
    lat: 53.0173,
    lng: -2.254172,
    domain: "wj.uk",
    description:
      "Road-marking and highway-safety group delivering lining, studs, surface treatments and specialist services.",
    hiActivity:
      "Project case studies, sustainability, awards, innovation, acquisitions, people and company news.",
    hiSearch: "https://www.highwaysindustry.com/?s=WJ",
    caseStudySlug: "wj-group",
  },
];

// Locally-stored hero images scraped from each client's website (OpenGraph)
// or falling back to a rich gradient hero. Missing entries render with the
// gradient hero used by ClientDetail.jsx.
const CLIENT_HERO_IMAGES = {
  blakedale: "/images/clients/blakedale.jpg",
  "cd-fencing": "/images/clients/cd-fencing.png",
  "city-tm": "/images/clients/city-tm.png",
  coeval: "/images/clients/coeval.png",
  "crown-highways": "/images/clients/crown-highways.png",
  "deltabloc-uk": "/images/clients/deltabloc-uk.jpeg",
  "highway-care": "/images/clients/highway-care.jpg",
  "hill-and-smith-infrastructure":
    "/images/clients/hill-and-smith-infrastructure.jpg",
  htm: "/images/clients/htm.jpeg",
  "kier-transportation-services":
    "/images/clients/kier-transportation-services.jpg",
  "messagemaker-displays-stocksigns-ltd":
    "/images/clients/messagemaker-displays-stocksigns-ltd.png",
  "metelec-services": "/images/clients/metelec-services.png",
  "miles-macadam": "/images/clients/miles-macadam.jpg",
  multevo: "/images/clients/multevo.jpg",
  pogo: "/images/clients/pogo.jpg",
  "re-flow": "/images/clients/re-flow.png",
  swarco: "/images/clients/swarco.jpg",
  "swarco-smart-charging": "/images/clients/swarco-smart-charging.jpg",
  "ths-training": "/images/clients/ths-training.jpg",
  "triangle-software": "/images/clients/triangle-software.png",
  "uk-sandbags": "/images/clients/uk-sandbags.jpg",
  velocity: "/images/clients/velocity.jpg",
  volkerhighways: "/images/clients/volkerhighways.jpg",
  wdm: "/images/clients/wdm.jpg",
};

export const CLIENTS = raw
  .map((c) => {
    const slug = slugify(c.name);
    const pitchData = CLIENT_PITCHES[slug] || {};
    return {
      ...c,
      slug,
      heroImage: CLIENT_HERO_IMAGES[slug] || null,
      pitch: pitchData.pitch || null,
      badges: pitchData.badges || [],
      hiServices: (CLIENT_SERVICES[slug] && CLIENT_SERVICES[slug].services) || [],
      partnership: (CLIENT_SERVICES[slug] && CLIENT_SERVICES[slug].partnership) || null,
    };
  })
  .sort((a, b) => a.name.localeCompare(b.name));

export const getClientBySlug = (slug) =>
  CLIENTS.find((c) => c.slug === slug);
